import { useEffect, useState } from "react";
import axios from "axios";
import useGlobalContext from "../../../../hooks/useGlobalContext";
import localize from "../../../../common/localize";

export default function ReportImageFieldValue({ valueId, original }) {
  const { DYNAMIC_FORM_FIELD_VALUE_ENDPOINT, config } = useGlobalContext();
  const [imageBlob, setImageBlob] = useState();

  const downloadEvidence = async () => {
    const image = await axios({
      ...config,
      method: "get",
      responseType: "blob", // Force to receive data in a Blob Format
      url: `${DYNAMIC_FORM_FIELD_VALUE_ENDPOINT}/field/${valueId}/download/${original}`,
    });

    if (image?.data) {
      const blob = new Blob([image.data], {
        type: "application/octet-stream",
      });

      const urlBlob = URL.createObjectURL(blob);
      setImageBlob(urlBlob);
    }
  };

  useEffect(() => {
    if (valueId > 0) {
      downloadEvidence();
    } else {
      setImageBlob(undefined);
    }
    return () => {
      if (imageBlob) URL.revokeObjectURL(imageBlob);
    };
  }, [valueId]);

  return (
    <div>
      {imageBlob ? (
        <img
          src={imageBlob}
          alt=""
          style={{ width: "250px", height: "320px", border: "1px solid" }}
        />
      ) : (
        <label className="report_little_text">{localize.no_data}</label>
      )}
    </div>
  );
}
